import axios from 'axios';
import AOS from 'aos';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules'
import * as d3 from "d3";

// import images
require.context('./images', false, /\.(png|jpg|jpeg|svg)$/);

// init aos
AOS.init({once: true});


const mobileButtonSetup = () => {

  // site navigation mobile button
  const $siteNavMobileButton = document.querySelector('.mbutton');
  if($siteNavMobileButton){
    $siteNavMobileButton.addEventListener('click', (event) => {
      
      // prevent default
      event.preventDefault();

      // get site nav
      const $siteNav = document.querySelector('.npsiteheader');

      // toggle class
      $siteNav.classList.toggle("open");

    });
  }

}

const scrollbarSetup = () => {
  const progressBar = document.getElementById("scroll-progress");
  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = (scrollTop / documentHeight) * 100;
    progressBar.style.width = `${progress}%`;
  });
}

const adDemo = () => {
  return;
  const ads = document.querySelectorAll('.npads .ad');
  if(!ads) return;

  setInterval(() => {
    const visible = [...ads].filter(ad => !ad.classList.contains('hidden'));
    const hidden = [...ads].filter(ad => ad.classList.contains('hidden'));

    if (!hidden.length) return;

    const oldAd = visible[Math.floor(Math.random() * visible.length)];
    const newAd = hidden[Math.floor(Math.random() * hidden.length)];

    oldAd.classList.add('hidden');
    newAd.classList.remove('hidden');
  }, 2000);

}

const eformSetup = () => {

  // get all forms elements
  const forms = document.querySelectorAll('.eform');

  // add event listener
  forms.forEach((form, index) => {
    form.addEventListener('submit', async (event) => {

      // prevent default
      event.preventDefault();

      // get submit data
      const $submit = form.querySelector(`.submit`);

      // disable submit button
      $submit.disabled=true;

      // get form data
      const formData = new FormData(form);

      // get url
      const url = form.dataset.url;

      // submit form data
      axios({
        baseURL: window.location.origin,
        method: "post",
        url: url,
        data: formData,
      }).then(function (response) {
        console.log(response);
        const $response = form.querySelector(`.response`);
        $response.innerHTML = "";
        $response.style.display = "block";
        $response.classList.remove("error");
        $response.classList.add("success");
        const $elm = document.createElement("p");
        $elm.innerHTML = response.data.message
        $response.appendChild($elm);
        if(response.data.redirect) window.location.href = response.data.redirect;
      }).catch((error)=>{
        const $response = form.querySelector(`.response`);
        $submit.disabled=false;
        $response.innerHTML = "";
        $response.style.display = "block";
        $response.classList.add("error");
        $response.classList.remove("success");
        if(error.response.data.redirect) window.location.href = error.response.data.redirect;
        if(error.response.status === 400 && error.response.data.length){
          error.response.data.forEach(value=>{
            const $elm = document.createElement("p");
            $elm.innerHTML = value.message
            $response.appendChild($elm);
          })
        }
        if(error.response.status === 500 || error.response.status === 401){
          const $elm = document.createElement("p");
          $elm.innerHTML = error.response.data.message
          $response.appendChild($elm);
        }
      });

    });
  });

}

const swiperSetup = () => {
  const swipers1 = document.querySelectorAll('.swipernav');
  swipers1.forEach((swiper, index) => {
    swiper.classList.add(`swiper${index}`);
    const total = swiper.querySelectorAll(`a`).length;
    new Swiper(`.swiper${index}`, {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 2,
      loop: false,
      navigation: {
        nextEl: `.swiper${index} .swiper-button-next`,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 5,
        },
        992: {
          slidesPerView: 6,
        },
        1231: {
          slidesPerView: 8,
        }
      }
    });
  });
}

const interactiveDemo = async () => {

  const demo = document.getElementById('np-demo');
  if(!demo) return;
  const sectionForm = document.getElementById('section-form');
  const inputUrl = document.getElementById('input-url');
  const inputCta = document.getElementById('input-cta');
  const inputChat = document.getElementById('input-chat');
  const chatText = document.getElementById('input-chat-text');
  const slider = document.getElementById('input-budget');
  const goal = document.getElementById('input-goal');
  const sectionScreenshot = document.getElementById('section-screenshot');
  const sectionHtml = document.getElementById('section-html');
  const sectionKeywords = document.getElementById('section-keywords');
  const keywords = sectionKeywords.querySelectorAll('.keyword');
  const sectionAds = document.getElementById('section-ads');
  const ads = sectionAds.querySelectorAll('.ad');
  const sectionCpa = document.getElementById('section-cpa');
  const tableRows = sectionCpa.querySelectorAll('tr');

  const observer = new IntersectionObserver(async (entries) => {
    if (entries[0].isIntersecting) {

      // disconnect
      observer.disconnect();
      
      // Type chat text
      for (const char of 'Setting Up Your Campaign') {
        chatText.textContent += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // Type URL
      for (const char of 'www.mylandingpage.com/limited-time-offer/') {
        inputUrl.value += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // Animate budget
      for (let value = 500; value <= 5000; value += 500) {
        slider.value = value;
        slider.dispatchEvent(new Event('input', { bubbles: true }));
        await new Promise(resolve => setTimeout(resolve, 50));
      }

      // Select Sales
      goal.value = 'sales';
      goal.dispatchEvent(new Event('change', { bubbles: true }));

      // await for goal
      await new Promise(resolve => setTimeout(resolve, 500));

      // Type chat text
      chatText.textContent = '';
      for (const char of 'Taking Screenshot') {
        chatText.textContent += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // await for chat
      await new Promise(resolve => setTimeout(resolve, 500));

      // Show screenshot section
      sectionScreenshot.style.display = 'inline-block';
      //sectionForm.style.display = 'none';

      // Type chat text
      chatText.textContent = '';
      for (const char of 'Getting HTML') {
        chatText.textContent += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // await for chat
      await new Promise(resolve => setTimeout(resolve, 500));

      // Show screenshot section
      sectionHtml.style.display = 'inline-block';
      //sectionScreenshot.style.display = 'none';

      // Type chat text
      chatText.textContent = '';
      for (const char of 'Choosing Keywords') {
        chatText.textContent += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // await for chat
      await new Promise(resolve => setTimeout(resolve, 500));

      // Show keywords section
      sectionKeywords.style.display = 'inline-block';
      //sectionHtml.style.display = 'none';

      // Show keywords one by one
      for (const keyword of keywords) {
        keyword.style.display = 'inline-block';
        await new Promise(resolve => setTimeout(resolve, 150));
      }

      // Type chat text
      chatText.textContent = '';
      for (const char of 'Creating Your Ads') {
        chatText.textContent += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // await for chat
      await new Promise(resolve => setTimeout(resolve, 500));

      // Show ads section
      sectionAds.style.display = 'inline-block';
      //sectionKeywords.style.display = 'none';

      // Show ads one by one
      for (const ad of ads) {
        ad.style.display = 'block';
        await new Promise(resolve => setTimeout(resolve, 500));
      }

      // Type chat text
      chatText.textContent = '';
      for (const char of 'Calculating CPA') {
        chatText.textContent += char;
        await new Promise(resolve => setTimeout(resolve, 25));
      }

      // await for chat
      await new Promise(resolve => setTimeout(resolve, 500));

      // Show ads section
      sectionCpa.style.display = 'inline-block';
      //sectionAds.style.display = 'none';

      // Show ads one by one
      for (const row of tableRows) {
        row.style.display = 'table-row';
        await new Promise(resolve => setTimeout(resolve, 250));
      }

      // Show cta
      inputCta.style.display = 'block';
      inputChat.style.display = 'none';

    }
  },{threshold: 0.7});

  observer.observe(demo);

};

const d3Setup1 = () => {

    // Sample keywords attached to each spoke
    const sampleKeywords = [
      "Fresh Meals Deliveries", "Healthy Eating Made Effortless", "Healthy Meals To Your Door", "Get 50% Off Your First Box", "Chef-Crafted Healthy Meals", "Healthy Meals From $6/Serving", "Expert Interior Design Service", "Custom Interior Design Solutions", "Book Your Free Consultation", "Transform Your Home Today", "Stress-Free Home Redesign", "Affordable Luxury Design"
    ];

    const data = Array.from({ length: 48 }, (_, i) => ({
      id: i,
      keyword: sampleKeywords[i % sampleKeywords.length],
      value: Math.random() * 8 + 2
    }));

    // Base coordinate system setup
    const baseSize = 750; // Increased size to make room for outer text labels
    const center = baseSize / 2;
    const innerRadius = 120;
    const maxBarLength = 150;

    const svg = d3.select("#radial-chart")
      .append("svg")
      .attr("viewBox", `0 0 ${baseSize} ${baseSize}`)
      .attr("preserveAspectRatio", "xMidYMid meet");

    const chartGroup = svg.append("g")
      .attr("transform", `translate(${center}, ${center})`);

    const maxValue = d3.max(data, d => d.value);
    const radiusScale = d3.scaleLinear().domain([0, maxValue]).range([0, maxBarLength]);
    const numSpokes = data.length;
    const angleStep = (2 * Math.PI) / numSpokes;

    // 1. Center Hub
    const hubGroup = chartGroup.append("g");
    hubGroup.append("circle").attr("r", innerRadius).attr("fill", "none").attr("stroke", "#3c83f66b");
    
    [0.3, 0.6, 0.8].forEach(factor => {
      hubGroup.append("circle").attr("r", innerRadius * factor).attr("fill", "none").attr("stroke", "#3c83f66b").attr("stroke-dasharray", "2,2");
    });

    hubGroup.append("line").attr("x1", 0).attr("y1", -innerRadius).attr("x2", 0).attr("y2", innerRadius).attr("stroke", "#3c83f66b");
    // hubGroup.append("line").attr("x1", 0).attr("y1", 0).attr("x2", innerRadius).attr("y2", 0).attr("stroke", "#333");

    // 2. Blue Spoke Lines (#3c83f6)
    chartGroup.selectAll(".spoke")
      .data(data)
      .enter()
      .append("line")
      .attr("class", "spoke")
      .attr("x1", (d, i) => innerRadius * Math.cos(i * angleStep - Math.PI / 2))
      .attr("y1", (d, i) => innerRadius * Math.sin(i * angleStep - Math.PI / 2))
      .attr("x2", (d, i) => (innerRadius + radiusScale(d.value)) * Math.cos(i * angleStep - Math.PI / 2))
      .attr("y2", (d, i) => (innerRadius + radiusScale(d.value)) * Math.sin(i * angleStep - Math.PI / 2))
      .attr("stroke", "#3c83f66b")
      .attr("stroke-width", 1.5)
      .attr("stroke-linecap", "round");

    // 3. Attach Words to the Tip of Each Line
    chartGroup.selectAll(".spoke-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "spoke-label")
      .attr("transform", (d, i) => {
        const angle = i * angleStep - Math.PI / 2;
        const labelRadius = innerRadius + radiusScale(d.value) + 6; // Position 6px past the line tip
        const x = labelRadius * Math.cos(angle);
        const y = labelRadius * Math.sin(angle);
        
        let angleDeg = (angle * 180) / Math.PI;

        // Flip text on the left half of the circle so it reads left-to-right
        if (x < 0) {
          angleDeg += 180;
        }

        return `translate(${x}, ${y}) rotate(${angleDeg})`;
      })
      .attr("text-anchor", (d, i) => {
        const angle = i * angleStep - Math.PI / 2;
        const x = Math.cos(angle);
        return x < 0 ? "end" : "start";
      })
      .attr("dominant-baseline", "central")
      .text(d => d.keyword);
}

const d3Setup2 = () => {

  // -----------------------------------
  // DATA
  // -----------------------------------

  const sampleKeywords = [
    "Fresh Meals Deliveries",
    "Healthy Eating Made Effortless",
    "Healthy Meals To Your Door",
    "Get 50% Off Your First Box",
    "Chef-Crafted Healthy Meals",
    "Healthy Meals From $6/Serving",
    "Expert Interior Design Service",
    "Custom Interior Design Solutions",
    "Book Your Free Consultation",
    "Transform Your Home Today",
    "Stress-Free Home Redesign",
    "Affordable Luxury Design"
  ];

  const data = Array.from({ length: 48 }, (_, i) => ({
    id: i,
    keyword: sampleKeywords[i % sampleKeywords.length],
    value: Math.random() * 8 + 2
  }));


  // -----------------------------------
  // CONFIG
  // -----------------------------------

  const baseSize = 400;
  const center = baseSize / 2;

  const innerRadius = 70;
  const maxBarLength = 90;

  const numSpokes = data.length;
  const angleStep = (2 * Math.PI) / numSpokes;


  // -----------------------------------
  // SVG
  // -----------------------------------

  const svg = d3.select("#radial-chart")
    .append("svg")
    .attr("viewBox", `0 0 ${baseSize} ${baseSize}`)
    .attr("preserveAspectRatio", "xMidYMid meet");


  const chartGroup = svg.append("g")
    .attr("transform", `translate(${center}, ${center})`);


  // -----------------------------------
  // SCALE
  // -----------------------------------

  const maxValue = d3.max(data, d => d.value);

  const radiusScale = d3.scaleLinear()
    .domain([0, maxValue])
    .range([0, maxBarLength]);


  // -----------------------------------
  // CENTER HUB
  // -----------------------------------

  const hubGroup = chartGroup.append("g");

  hubGroup
    .append("circle")
    .attr("r", innerRadius)
    .attr("fill", "none")
    .attr("stroke-width", 0.5)
    .attr("stroke", "#3c83f652");

  [0.3, 0.6, 0.8].forEach(factor => {

    hubGroup
      .append("circle")
      .attr("r", innerRadius * factor)
      .attr("fill", "none")
      .attr("stroke", "#3c83f652")
      .attr("stroke-width", 0.5)
      .attr("stroke-dasharray", "2,2");

  });

  hubGroup
    .append("line")
    .attr("x1", 0)
    .attr("y1", -innerRadius)
    .attr("x2", 0)
    .attr("y2", innerRadius)
    .attr("stroke", "#3c83f652")
    .attr("stroke-width", 0.5);


  // -----------------------------------
  // SPIKES
  // -----------------------------------
  const spokes = chartGroup
    .selectAll(".spoke")
    .data(data)
    .enter()
    .append("line")
    .attr("class", "spoke")
    .attr("stroke", "#3c83f652")
    .attr("stroke-width", 0.5)
    .attr("stroke-linecap", "round")
    .attr("x1", (d, i) => {

      const angle = i * angleStep - Math.PI / 2;

      return innerRadius * Math.cos(angle);

    })
    .attr("y1", (d, i) => {

      const angle = i * angleStep - Math.PI / 2;

      return innerRadius * Math.sin(angle);

    })
    .attr("x2", (d, i) => {

      const angle = i * angleStep - Math.PI / 2;
      const radius = innerRadius + radiusScale(d.value);

      return radius * Math.cos(angle);

    })
    .attr("y2", (d, i) => {

      const angle = i * angleStep - Math.PI / 2;
      const radius = innerRadius + radiusScale(d.value);

      return radius * Math.sin(angle);

    });


  // -----------------------------------
  // LABELS
  // -----------------------------------

  const labels = chartGroup
    .selectAll(".spoke-label")
    .data(data)
    .enter()
    .append("text")
    .attr("class", "spoke-label")
    .attr("font-size", "10px")
    .attr("fill", "#333")
    .attr("dominant-baseline", "central")
    .text(d => d.keyword);


  // -----------------------------------
  // POSITION LABEL
  // -----------------------------------
  //
  // IMPORTANT:
  // The text itself is NOT rotated.
  // This keeps every keyword horizontal.
  //

  function positionLabel(label, i, radius) {

    const angle = i * angleStep - Math.PI / 2;

    const x = radius * Math.cos(angle);
    const y = radius * Math.sin(angle);

    // Keep text readable on both sides.
    const anchor = Math.cos(angle) < 0
      ? "end"
      : "start";

    label
      .attr("x", x)
      .attr("y", y)
      .attr("text-anchor", anchor);

  }


  // Position initial labels
  labels.each(function(d, i) {

    const radius =
      innerRadius +
      radiusScale(d.value) +
      10;

    positionLabel(
      d3.select(this),
      i,
      radius
    );

  });


  // -----------------------------------
  // ANIMATION
  // -----------------------------------
  return;
  spokes.each(function(d, i) {

    const spoke = d3.select(this);

    const label = labels.filter((labelData, labelIndex) => {
      return labelIndex === i;
    });

    const angle =
      i * angleStep -
      Math.PI / 2;


    function animate() {

      // Current spike length
      const currentLength = radiusScale(d.value);

      // New random length
      const newValue =
        Math.random() * 8 + 2;

      const newLength =
        radiusScale(newValue);

      const startRadius =
        innerRadius + currentLength;

      const endRadius =
        innerRadius + newLength;


      // Animation duration
      const duration =
        900 + Math.random() * 1200;


      // Animate spike
      spoke
        .transition()
        .duration(duration)
        .ease(d3.easeSinInOut)

        .attr(
          "x2",
          endRadius * Math.cos(angle)
        )

        .attr(
          "y2",
          endRadius * Math.sin(angle)
        );


      // Animate label
      label
        .transition()
        .duration(duration)
        .ease(d3.easeSinInOut)

        .attr(
          "x",
          (endRadius + 10) * Math.cos(angle)
        )

        .attr(
          "y",
          (endRadius + 10) * Math.sin(angle)
        )

        .on("end", () => {

          // Remember the new value
          d.value = newValue;

          // Start next animation
          animate();

        });

    }


    // Start each spike at a different time
    setTimeout(
      animate,
      Math.random() * 20000
    );

  });

};

const d3Setup3 = () => {

  // -----------------------------------
  // DATA
  // -----------------------------------

  const sampleKeywords = [
    "Fresh Meals Deliveries",
    "Healthy Eating Made Effortless",
    "Healthy Meals To Your Door",
    "Get 50% Off Your First Box",
    "Chef-Crafted Healthy Meals",
    "Healthy Meals From $6/Serving",
    "Expert Interior Design Service",
    "Custom Interior Design Solutions",
    "Book Your Free Consultation",
    "Transform Your Home Today",
    "Stress-Free Home Redesign",
    "Affordable Luxury Design"
  ];

  const data = Array.from({ length: 48 }, (_, i) => ({
    id: i,
    keyword: sampleKeywords[i % sampleKeywords.length],
    value: Math.random() * 8 + 2
  }));


  // -----------------------------------
  // CONFIG
  // -----------------------------------

  const baseSize = 400;
  const center = baseSize / 2;

  const innerRadius = 70;
  const maxBarLength = 90;

  const numSpokes = data.length;
  const angleStep = (2 * Math.PI) / numSpokes;


  // -----------------------------------
  // SVG
  // -----------------------------------

  const svg = d3.select("#radial-chart")
    .append("svg")
    .attr("viewBox", `0 0 ${baseSize} ${baseSize}`)
    .attr("preserveAspectRatio", "xMidYMid meet");


  const chartGroup = svg.append("g")
    .attr("transform", `translate(${center}, ${center})`);


  // -----------------------------------
  // SCALE
  // -----------------------------------

  const maxValue = d3.max(data, d => d.value);

  const radiusScale = d3.scaleLinear()
    .domain([0, maxValue])
    .range([0, maxBarLength]);


  // -----------------------------------
  // CENTER HUB
  // -----------------------------------

  const hubGroup = chartGroup.append("g");

  hubGroup
    .append("circle")
    .attr("r", innerRadius)
    .attr("fill", "none")
    .attr("stroke-width", 0.5)
    .attr("stroke", "#3c83f652");


  [0.3, 0.6, 0.8].forEach(factor => {

    hubGroup
      .append("circle")
      .attr("r", innerRadius * factor)
      .attr("fill", "none")
      .attr("stroke", "#3c83f652")
      .attr("stroke-width", 0.5)
      .attr("stroke-dasharray", "2,2");

  });


  hubGroup
    .append("line")
    .attr("x1", 0)
    .attr("y1", -innerRadius)
    .attr("x2", 0)
    .attr("y2", innerRadius)
    .attr("stroke", "#3c83f652")
    .attr("stroke-width", 0.5);


  // -----------------------------------
  // SPIKES
  // -----------------------------------

  const spokes = chartGroup
    .selectAll(".spoke")
    .data(data)
    .enter()
    .append("line")
    .attr("class", "spoke")
    .attr("stroke", "#3c83f652")
    .attr("stroke-width", 0.5)
    .attr("stroke-linecap", "round")
    .attr("x1", (d, i) => {

      const angle =
        i * angleStep - Math.PI / 2;

      return innerRadius * Math.cos(angle);

    })
    .attr("y1", (d, i) => {

      const angle =
        i * angleStep - Math.PI / 2;

      return innerRadius * Math.sin(angle);

    })
    .attr("x2", (d, i) => {

      const angle =
        i * angleStep - Math.PI / 2;

      const radius =
        innerRadius + radiusScale(d.value);

      return radius * Math.cos(angle);

    })
    .attr("y2", (d, i) => {

      const angle =
        i * angleStep - Math.PI / 2;

      const radius =
        innerRadius + radiusScale(d.value);

      return radius * Math.sin(angle);

    });


  // -----------------------------------
  // LABELS
  // -----------------------------------

  const labels = chartGroup
    .selectAll(".spoke-label")
    .data(data)
    .enter()
    .append("text")
    .attr("class", "spoke-label")
    .attr("font-size", "10px")
    .attr("fill", "#333")
    .attr("dominant-baseline", "central")
    .text(d => d.keyword);


  // -----------------------------------
  // POSITION LABEL
  // -----------------------------------

  function positionLabel(label, i, radius) {

    const angle =
      i * angleStep - Math.PI / 2;

    const x =
      radius * Math.cos(angle);

    const y =
      radius * Math.sin(angle);

    const anchor =
      Math.cos(angle) < 0
        ? "end"
        : "start";

    label
      .attr("x", x)
      .attr("y", y)
      .attr("text-anchor", anchor);

  }


  // Position initial labels
  labels.each(function(d, i) {

    const radius =
      innerRadius +
      radiusScale(d.value) +
      10;

    positionLabel(
      d3.select(this),
      i,
      radius
    );

  });


  // -----------------------------------
  // SCROLL ANIMATION
  // -----------------------------------

  let targetScroll = window.scrollY;
  let currentScroll = window.scrollY;

  // Track scroll position
  window.addEventListener("scroll", () => {

    targetScroll = window.scrollY;

  }, { passive: true });


  // -----------------------------------
  // SPIKE VALUES
  // -----------------------------------

  // Give every spike a slightly different
  // starting value.

  const spikeStates = data.map((d, i) => {

    return {
      current: radiusScale(d.value),
      target: radiusScale(d.value),

      // Gives every spike a different
      // response to scrolling.
      offset: Math.random() * Math.PI * 2,

      // Slightly different sensitivity.
      sensitivity: 0.7 + Math.random() * 0.6
    };

  });


  // -----------------------------------
  // ANIMATION LOOP
  // -----------------------------------

  function animate() {

    // Smoothly follow the actual scroll position
    currentScroll +=
      (targetScroll - currentScroll) * 0.08;


    spokes.each(function(d, i) {

      const spoke =
        d3.select(this);

      const state =
        spikeStates[i];


      // -----------------------------------
      // SCROLL WAVE
      // -----------------------------------

      const wave =
        Math.sin(
          currentScroll * 0.012 * state.sensitivity +
          state.offset
        );


      // Convert -1 → 1
      // into 0 → 1

      const normalized =
        (wave + 1) / 2;


      // -----------------------------------
      // TARGET LENGTH
      // -----------------------------------

      const minLength = 15;

      const maxLength =
        maxBarLength;


      state.target =
        minLength +
        normalized *
        (maxLength - minLength);


      // -----------------------------------
      // SMOOTH SPIKE MOVEMENT
      // -----------------------------------

      state.current +=
        (state.target - state.current) * 0.08;


      const radius =
        innerRadius +
        state.current;


      const angle =
        i * angleStep -
        Math.PI / 2;


      // -----------------------------------
      // UPDATE SPIKE
      // -----------------------------------

      spoke
        .attr(
          "x2",
          radius * Math.cos(angle)
        )
        .attr(
          "y2",
          radius * Math.sin(angle)
        );


      // -----------------------------------
      // UPDATE LABEL
      // -----------------------------------

      const label =
        labels.filter((labelData, labelIndex) => {
          return labelIndex === i;
        });


      label
        .attr(
          "x",
          (radius + 10) *
          Math.cos(angle)
        )
        .attr(
          "y",
          (radius + 10) *
          Math.sin(angle)
        );

    });


    requestAnimationFrame(animate);

  }


  // Start animation
  requestAnimationFrame(animate);

};

eformSetup();
swiperSetup();
interactiveDemo();
mobileButtonSetup();
adDemo();
d3Setup2();
scrollbarSetup();